import { Component, OnInit,  } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup,  Validators } from '@angular/forms';
import { AccountService } from '@app/_services/account.service';
import { AlertService } from '@app/_services/alert.service';
import { ConfigDataService } from '@app/_services/config-data.service'
import { MakeModel } from '@app/_models/makeModel';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { StateCity } from '@app/_models/stateCity';
import { PlanDetails } from '@app/_models/planDetails';
import { User } from '@app/_models';
import { DealerService } from '@app/_services/dealer-service';
import { Dealer } from '@app/_models/dealer';
import { Certificate } from '@app/_models/certificate';
import { CertificateService } from '@app/_services/certificate.service'
import { first } from 'rxjs/internal/operators/first';
import { CertificateResponse } from '@app/_models/certificateResponse';
import { ActivatedRoute, Router } from '@angular/router';
import { DealerModelConfig } from '@app/_models/dealerModelConfig';
import { DealerModelPrice } from '@app/_models/dealerModelPrice';
import { PrintInstruction } from '@app/_models/printInstruction';
import { ExtractedData } from '@app/_models/extracted-data.model';
import { PopulationResult } from '@app/_models/field-mapping.model';
import { CommonFunctionService } from '@app/_services/common-function.service';



@Component({
  selector: 'app-add-certificate',
  templateUrl: './add-certificate.component.html',
  styleUrls: ['./add-certificate.component.less']
})
export class AddCertificateComponent implements OnInit {
  certficateForm: UntypedFormGroup;
  showGstAmount = true;
  loading = false;
  isBalanceLow = false;
  firstTime = true;
  submitted = false;
  dealer = new Dealer();
  makeModel: MakeModel[];
  configMakeModel: MakeModel[];
  models: string[];
  cities: string[];
  financeCompanies: string[] ;
  selectedFinanceCompanies: string[];
  stateCity: StateCity[];
  plans: PlanDetails[];
  // twoWheelerPlans: PlanDetails[];
  // nonTwoWheelerPlans: PlanDetails[];
  maxAmount = 99999;
  minAmount = 0;
  showFinance = false;
  selectedMakeModel: MakeModel;
  selectedPlan= new PlanDetails();
  selectedFinance:string;
  nameRegexp = new RegExp("",'i');
  startDateModel: NgbDateStruct;
  dobString: string;
  customerDob: string;
  runningBalance: number;
  types = ["New", "Old"];
  genders = ["Male", "Female"];
  clientTypes = ["Individual", "Corporate"];
  years: number[];
  relationships = ["Spouse","Husband","Wife", "Father", "Mother", "Son", "Daughter", "Brother", "Sister","Grandson","Granddaughter", "Other"];
  registrtionNumberValidation = [];
  certificateResponse: CertificateResponse;
  planAmount: any;
  user: User;
  gSTAmount: number;
  gstPercentage = 0.18;
  isCorporate = true;
  User: User;
  planGSTAmount: any;
  planTotalAmount: any;
  currentDate = new Date();
  certificateCreated = false;
  issueDateString: string;
  issueDate : Date;
  startDate : Date;
  endDate : Date;
  minDobDate : Date;
  maxDobDate : Date;
  ageOrDobValue = ["dob","age"];
  minDobDateModel =  {"year":2010, "month": 1,"day": 1};
  maxDobDateModel =  {"year":2010, "month": 1,"day": 1};
  maxDateModel=  {"year":2010, "month": 1,"day": 1};
  oneMonthAddDate = new Date();
  newMaxDateModel=  {"year":new Date().getFullYear(), "month": 1,"day": 1};
  oldMaxDateModel=  {"year":new Date().getFullYear() + 1, "month": 1,"day": 1};
  newYears : Number[];
  showPaymentButton = false;
  showPaymentGatewayForm = false;
  renewCertificate = false;  
  oldCertificateValue: Certificate;
  insPolicyTotalAmount: number;
  insPolicyAmount: number;
  dealarConfigFound: boolean = false;
  dealerConfig: DealerModelConfig;
  selectDealerModelPrice: DealerModelPrice;
  automationFlag = false;
  disclaimerExpanded = false;

  get isHeroDealer(): boolean {
    return this.dealer?.dealerMake?.some((m: any) => m.make === 'Hero Motocorp Limited') ?? false;
  }

  onAutomationFlagChange() {
    if (this.automationFlag) {
      this.certficateForm.patchValue({ vehicleMake: 'Hero Motocorp Limited' });
    }
  }
  allDealerConfig: DealerModelConfig[] =[];
  printInstructions: PrintInstruction[]=[];

  // Field highlighting tracking
  modifiedFields = new Set<string>();
  requiredFields = new Set<string>();
  autoPopulatedFields = new Set<string>();
  manuallyFilledFields = new Set<string>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private accountService: AccountService,
    private alertService: AlertService,
    private configDataService: ConfigDataService,
    private dealerService: DealerService,
    private certificateService: CertificateService,
    private route: ActivatedRoute,
    private router: Router,
    private commonFunctionService: CommonFunctionService,

  ) {

  }

  ngOnInit(): void {
    this.renewCertificate = this.router.url.includes('renewCertificate');
    this.user = this.accountService.userValue;
    this.selectDealerModelPrice = new DealerModelPrice();
    this.selectDealerModelPrice.totalAmount = 0;
    this.selectDealerModelPrice.insuranceAmount = 0;
    this.selectDealerModelPrice.allianceAmount = 0;

    this.certficateForm = this.formBuilder.group({
      vehicleMake: ['', Validators.required],
      model: ['', Validators.required],
      type: ['', Validators.required],
      variant: [''],
      vehicleYear: [''],
      registrationNumber: [''],
      chasisNumber: ['', Validators.required],
      engineNumber: ['', Validators.required],
      clientType:['',Validators.required],
      firstName: ['', [Validators.required, Validators.pattern('^[^0-9]+$')]],
      middleName: [''],
      lastName: ['', [Validators.pattern('^[^0-9]+$')]],
      vehicleType: ['Two Wheeler'],
      email: ['', [ Validators.email]],
      contactNumber: ['', [Validators.required, Validators.minLength(6)]],
      employeeContactNumber: ['', [Validators.required, Validators.minLength(6)]],
      gender: ['', Validators.required],
      dob: ['', Validators.required],
      ageOrDob: [this.ageOrDobValue[0]],
      gstin: [''],
      address: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      nomineeName: ['', Validators.required],
      nomineeRelationship: ['', Validators.required],
      nomineeGender: ['', Validators.required],
      nomineeAge: ['', [Validators.required, Validators.min(1),Validators.max(100)]],
      age: ['', [Validators.required, Validators.min(15),Validators.max(80)]],
      planId: ['', Validators.required],
      planAmount: ['']
      , planGSTAmount: ['']
      , planTotalAmount: ['', [Validators.required,
      (control: AbstractControl) => Validators.max(this.maxAmount)(control)
        , (control: AbstractControl) => Validators.min(this.minAmount)(control)]]
      , startDate: ['', Validators.required]
      , endDate: ['']
      , issueDate: ['']
      , balance: ['']
      , userId: ['']
      , certificateNumber: ['']
      , policyNumber: ['']
      , financeCompanyName: ['']
      , financeCoverAmount: [50000]
      ,insPolicyAmount:[{value:0,'disabled':true},[Validators.required,Validators.min(0),Validators.max(40000)]]
      ,insPolicyGStAmount:[{value:0,'disabled':true},Validators.required]
      ,insPolicyTotalAmount:[0,[Validators.required,Validators.min(0),Validators.max(40000)]]
      ,packageAmount:[{value:0,'disabled':true}]
      ,packageGstAmount:[{value:0,'disabled':true}]
      ,packageTotalAmount:[{value:0,'disabled':true}]
    });
    this.configDataService.FinanceCompanyList$.subscribe((x) => {
      this.financeCompanies = x;
    });
    this.startDateModel =  {"year":2010, "month": 1,"day": 1};
    this.startDateModel.year = this.currentDate.getFullYear();
    this.startDateModel.day = this.currentDate.getDate();
    this.startDateModel.month = this.currentDate.getMonth() + 1;



    this.configDataService.getTodaysDate()
    .subscribe(x => {
      this.currentDate = new Date(x);
      this.issueDate = new Date(x);
      this.startDate = new Date(x);
      // End date: 1 year minus 1 day from start date, set to 23:59:59.999 IST
      const endDateCalc = new Date(x);
      endDateCalc.setFullYear(endDateCalc.getFullYear() + 1);
      endDateCalc.setDate(endDateCalc.getDate() - 1);
      endDateCalc.setHours(23, 59, 59, 999);
      this.endDate = endDateCalc;
      this.minDobDate = new Date(new Date().setFullYear(this.currentDate.getFullYear() - 80));
      this.maxDobDate = new Date(new Date().setFullYear(this.currentDate.getFullYear() - 15));
      this.newYears = [this.currentDate.getFullYear(), this.currentDate.getFullYear() - 1];
      this.oneMonthAddDate = new Date(this.currentDate);
      this.oneMonthAddDate = new Date(this.oneMonthAddDate.setMonth(this.oneMonthAddDate.getMonth() + 1));
      this.newMaxDateModel.year = this.oneMonthAddDate.getFullYear();
      this.newMaxDateModel.month = this.oneMonthAddDate.getMonth() + 1;
      this.newMaxDateModel.day = this.oneMonthAddDate.getDate();
      this.oldMaxDateModel.year = this.currentDate.getFullYear() + 1;
      this.oldMaxDateModel.month = this.currentDate.getMonth() + 1;
      this.oldMaxDateModel.day = this.currentDate.getDate();

      this.startDateModel.year = this.currentDate.getFullYear();
      this.startDateModel.day = this.currentDate.getDate();
      this.startDateModel.month = this.currentDate.getMonth() + 1;
      this.certficateForm.controls['startDate'].setValue(this.startDateModel);
  
      this.minDobDateModel.year = this.minDobDate.getFullYear();
      this.minDobDateModel.day = this.minDobDate.getDate();
      this.minDobDateModel.month = this.minDobDate.getMonth() + 1;
  
      this.maxDobDateModel.year = this.maxDobDate.getFullYear();
      this.maxDobDateModel.day = this.maxDobDate.getDate();
      this.maxDobDateModel.month = this.maxDobDate.getMonth() + 1;
      if (this.user.specialRoleAccess && this.user.specialRoleAccess.includes('canSeeAge'))
      {
        this.certficateForm.controls['ageOrDob'].setValue(this.ageOrDobValue[1]);
        this.certficateForm.get('dob').clearValidators(); 
        this.certficateForm.get('dob').updateValueAndValidity();
      }  
        

    this.configDataService.StateCity$.subscribe((x) => {
      this.stateCity = x;
    });
    // // this.configDataService.getMakeModel().subscribe((x)=>{
    // //   this.configMakeModel = x;
    // // }
    // )

    this.certficateForm.controls['planAmount'].disable();
    this.certficateForm.controls['planGSTAmount'].disable();
    this.certficateForm.controls['planTotalAmount'].disable();
    this.certficateForm.controls['endDate'].disable();
    this.certficateForm.controls['issueDate'].disable();
    this.certficateForm.controls['balance'].disable();

    // if ((this.user.role == "executive") || (this.user.role =="manager") || (this.user.role == "dealerOwner")) {
      this.dealerService.getByDealerId(this.user.dealerId).subscribe((x) => {
        this.dealer = x;
        this.plans = x.dealerPlan;
        this.certficateForm.controls['balance'].setValue(this.dealer.dealerBalance);
        // this.twoWheelerPlans = x.dealerPlan.filter(x => !x.policyType.includes('(CAR)'));
        // this.nonTwoWheelerPlans = x.dealerPlan.filter(x => x.policyType.includes('(CAR)'));
        this.showPaymentButton = this.dealer.dealerPaymentShow ? this.dealer.dealerPaymentShow == "Yes" ? true : false : false;
        this.makeModel = x.dealerMake;
        
        // Populate state and city from dealer data if available
        this.populateStateCityFromDealer();
        if (!this.dealer.dealerCreatePackage)
        {
          this.certficateForm.controls['insPolicyAmount'].clearValidators();
          this.certficateForm.controls['insPolicyGStAmount'].clearValidators();
          this.certficateForm.controls['insPolicyTotalAmount'].clearValidators();
          this.certficateForm.controls['insPolicyAmount'].updateValueAndValidity();
          this.certficateForm.controls['insPolicyGStAmount'].updateValueAndValidity();
          this.certficateForm.controls['insPolicyTotalAmount'].updateValueAndValidity();
        }
        this.configDataService.getDealerModelConfig(this.user.dealerId).pipe(first()).subscribe({
          next: (x) => {
            this.allDealerConfig = x;
            this.dealarConfigFound = false;
            this.certficateForm.controls['type'].setValue(this.types[0]);
            // this.dealerConfig = this.allDealerConfig.find(a=>[undefined,"Both","New"].includes(a.applicableOn));
            // if (this.allDealerConfig && this.allDealerConfig.length > 0){
            //   this.dealarConfigFound = true;
            // }
            // else 
            // {
            //   this.setDefaultMakeModel();
            // }
        },
        error: error => {
          // this.alertService.error(error);
          this.allDealerConfig = [];
          this.certficateForm.controls['type'].setValue(this.types[0]);
          // this.setDefaultMakeModel();
        }});
          }
      )

    this.certficateForm.controls['userId'].setValue(this.user.id);
    this.certficateForm.get('planAmount').disable;
    }
    )
    this.selectedPlan.numberOfYears = this.selectedPlan.numberOfYears? this.selectedPlan.numberOfYears : 1;

    if (this.renewCertificate)
    {
      this.renewCertificateUpdate();
    }
  this.maintainClientType();
    this.maintainModelandMakeValueChanges();
    this.maintainMiscValueChanges();
      this.maintainPlanValueChanges();
      this.maintainDateTimeValueChanges();
      
    // Initialize required fields highlighting
    this.highlightRequiredFields();
    
    // Subscribe to gender and nomineeRelationship changes for nominee gender guessing
    this.subscribeToNomineeGenderChanges();
    
    // Subscribe to form control changes to track manually filled fields
    this.trackManualFieldChanges();
  }
  getMakeModelFromDealerConfig() {
    this.makeModel = [...new Set(this.dealerConfig.dealerModelPrices.map(a => a.make))].map(a=> {
      return {
        make: a
      , model: [...new Set(this.dealerConfig.dealerModelPrices.filter(b => b.make == a).map(r=> r.model))]
      , productType: "Two Wheeler"
    }});
    if (!this.renewCertificate) {
      this.selectedMakeModel = this.makeModel[0];
      this.makeModelUpdatenonRenew();
    }
  else {
    this.selectedMakeModel = this.makeModel.find(x => x.make == this.oldCertificateValue.vehicleMake);        
    this.renewCertificateUpdateAfter();
  }        

}


  get f() { return this.certficateForm.controls; }
  setDefaultMakeModel(){
    this.configDataService.MakeModel$.subscribe(x => {
      if (!this.renewCertificate) {
        this.selectedMakeModel = x.find(x => x.make == this.makeModel[0].make);
        this.makeModelUpdatenonRenew();
      }
    else {
      this.makeModel = x;
      this.selectedMakeModel = x.find(x => x.make == this.oldCertificateValue.vehicleMake);
      this.renewCertificateUpdateAfter();
    }
    })
  }
  makeModelUpdatenonRenew(){

    this.certficateForm.controls['vehicleMake'].setValue(this.makeModel[0].make);
  this.certficateForm.controls['gender'].setValue(this.genders[0]);
  this.certficateForm.controls['nomineeGender'].setValue(this.genders[1]);
  this.certficateForm.controls['nomineeRelationship'].setValue(this.relationships[0]);
  this.certficateForm.controls['state'].setValue(this.dealer.dealerState);
  this.certficateForm.controls['clientType'].setValue(this.clientTypes[0]);
}
  renewCertificateUpdate(){
    this.oldCertificateValue = this.certificateService.PrintCertificate;
    this.certficateForm.controls['variant'].setValue(this.oldCertificateValue.variant);
    this.certficateForm.controls['registrationNumber'].setValue(this.oldCertificateValue.registrationNumber);
    this.certficateForm.controls['clientType'].setValue(this.oldCertificateValue.clientType?this.oldCertificateValue.clientType:this.clientTypes[0]);
    this.certficateForm.controls['engineNumber'].setValue(this.oldCertificateValue.engineNumber);
    this.certficateForm.controls['chasisNumber'].setValue(this.oldCertificateValue.chasisNumber);
    this.certficateForm.controls['firstName'].setValue(this.oldCertificateValue.firstName?this.oldCertificateValue.firstName:"");
    this.certficateForm.controls['lastName'].setValue(this.oldCertificateValue.lastName?this.oldCertificateValue.lastName:"");
    this.certficateForm.controls['middleName'].setValue("");
    this.certficateForm.controls['gstin'].setValue("");
    this.certficateForm.controls['vehicleType'].setValue("Two Wheeler");
    this.certficateForm.controls['email'].setValue(this.oldCertificateValue.email?this.oldCertificateValue.email:"");
    this.certficateForm.controls['contactNumber'].setValue(this.oldCertificateValue.contactNumber?this.oldCertificateValue.contactNumber:"");
    this.certficateForm.controls['employeeContactNumber'].setValue(this.oldCertificateValue.employeeContactNumber?this.oldCertificateValue.employeeContactNumber:"");
    this.certficateForm.controls['gender'].setValue(this.oldCertificateValue.gender?this.oldCertificateValue.gender:"");
    this.certficateForm.controls['address'].setValue(this.oldCertificateValue.address?this.oldCertificateValue.address:"");
    this.certficateForm.controls['state'].setValue(this.oldCertificateValue.state?this.oldCertificateValue.state:"");
    this.certficateForm.controls['city'].setValue(this.oldCertificateValue.city?this.oldCertificateValue.city:"");
    this.certficateForm.controls['nomineeName'].setValue(this.oldCertificateValue.nomineeName?this.oldCertificateValue.nomineeName:"");
    this.certficateForm.controls['nomineeRelationship'].setValue(this.oldCertificateValue.nomineeRelationship?this.oldCertificateValue.nomineeRelationship:"");
    this.certficateForm.controls['nomineeGender'].setValue(this.oldCertificateValue.nomineeGender?this.oldCertificateValue.nomineeGender:"");
    this.certficateForm.controls['nomineeAge'].setValue(this.oldCertificateValue.nomineeAge?this.oldCertificateValue.nomineeAge:"");
    this.certficateForm.controls['financeCompanyName'].setValue(this.oldCertificateValue.financeCompanyName?this.oldCertificateValue.financeCompanyName:"");
    this.certficateForm.controls['financeCoverAmount'].setValue(this.oldCertificateValue.financeCoverAmount?this.oldCertificateValue.financeCoverAmount:50000);
  }
  renewCertificateUpdateAfter(){
    this.certficateForm.controls['type'].setValue(this.types[1]); 
    if (this.oldCertificateValue.ageOrDob && this.oldCertificateValue.ageOrDob == this.ageOrDobValue[1])
    {
      this.certficateForm.controls['age'].setValue(this.oldCertificateValue.age);
      this.certficateForm.controls['dob'].setValue("NA");
    }
    else 
    {
    if (this.oldCertificateValue.dob != "NA")
    {
    this.startDateModel.year = parseInt(this.oldCertificateValue.dob.split('-')[0]);
    this.startDateModel.day = parseInt(this.oldCertificateValue.dob.split('-')[2]);
    this.startDateModel.month = parseInt(this.oldCertificateValue.dob.split('-')[1]);
    this.certficateForm.controls['dob'].setValue(this.startDateModel);
    }
    else
    {
      this.certficateForm.controls['dob'].setValue("NA");
    }
  }
    this.certficateForm.controls['clientType'].setValue(this.oldCertificateValue.clientType?this.oldCertificateValue.clientType:this.clientTypes[0]);
    this.certficateForm.controls['vehicleMake'].setValue(this.oldCertificateValue.vehicleMake);    
    this.certficateForm.controls['model'].setValue(this.oldCertificateValue.model);    
    this.certficateForm.controls['vehicleType'].setValue("Two Wheeler");
    this.certficateForm.controls['vehicleYear'].setValue(this.oldCertificateValue.vehicleYear);
    this.certficateForm.controls['state'].setValue(this.oldCertificateValue.state?this.oldCertificateValue.state:"");
    this.certficateForm.controls['city'].setValue(this.oldCertificateValue.city?this.oldCertificateValue.city:"");
    this.certficateForm.controls['nomineeName'].setValue(this.oldCertificateValue.nomineeName?this.oldCertificateValue.nomineeName:"");
    this.certficateForm.controls['nomineeRelationship'].setValue(this.oldCertificateValue.nomineeRelationship?this.oldCertificateValue.nomineeRelationship:"");
    this.certficateForm.controls['nomineeGender'].setValue(this.oldCertificateValue.nomineeGender?this.oldCertificateValue.nomineeGender:"");
    this.certficateForm.controls['nomineeAge'].setValue(this.oldCertificateValue.nomineeAge?this.oldCertificateValue.nomineeAge:"");
    this.certficateForm.controls['financeCompanyName'].setValue(this.oldCertificateValue.financeCompanyName?this.oldCertificateValue.financeCompanyName:"");
    this.certficateForm.controls['financeCoverAmount'].setValue(this.oldCertificateValue.financeCoverAmount?this.oldCertificateValue.financeCoverAmount:50000);
  }
  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();
    // stop here if form is invalid
    if (this.certficateForm.invalid) {
      return;
    }

    if (this.plans.length == 0) {
      this.alertService.error("No active corporate plans activated for corporate clients. Please request support@allianceassure to activate corporate plans for corporate clients")
      return;
    }
    this.loading = true;
    var issueCertificate: Certificate;
    issueCertificate = new Certificate(this.certficateForm.value);
    if (!issueCertificate.email)
        issueCertificate.email = " ";
    
    if (this.isCorporate)
    { 
      issueCertificate.gender = "Organisation"
      issueCertificate.dob = "NA"
      issueCertificate.nomineeRelationship = "NA"   
    }
    else{
      issueCertificate.employeeContactNumber = "NA";
      this.customerDob = this.customerDob = this.convertTextDate(this.certficateForm.get('dob').value);
      issueCertificate.dob = this.customerDob;
      }
    if (this.dealer.dealerCreatePackage)
    {
      issueCertificate.showSummaryPage =  true;
    }
    else
    {
      issueCertificate.showSummaryPage =  false;
    }
    if (this.dealer.onePager)
    {
      issueCertificate.onePager =  true;
    }
    else
    {
      issueCertificate.onePager =  false;
    }

    issueCertificate.issueDateString = this.issueDate.getFullYear() + "-" + ('0' + (this.issueDate.getMonth() + 1)).slice(-2) + "-" + ('0' + this.issueDate.getDate()).slice(-2);
    issueCertificate.planAmount = this.certficateForm.get('planAmount').value;
    issueCertificate.insPolicyAmount = this.certficateForm.get('insPolicyAmount').value;    
    issueCertificate.insPolicyGStAmount = this.certficateForm.get('insPolicyGStAmount').value;

    issueCertificate.planGSTAmount = this.certficateForm.get('planGSTAmount').value;
    issueCertificate.planTotalAmount = this.certficateForm.get('planTotalAmount').value;
    issueCertificate.startDate = this.certficateForm.get('issueDate').value;
    issueCertificate.endDate = this.certficateForm.get('endDate').value;
    issueCertificate.issueDate = this.certficateForm.get('issueDate').value;
    issueCertificate.printCpaPolicy = this.selectedPlan.printCpaPolicy?this.selectedPlan.printCpaPolicy:"Yes";
    issueCertificate.financeCompanyName =  this.certficateForm.get('financeCompanyName').value;
    issueCertificate.financeCoverAmount =  this.certficateForm.get('financeCoverAmount').value;

    issueCertificate.planCPACoverAmount = this.selectedPlan.planCPACoverAmount?this.selectedPlan.planCPACoverAmount : 1500000;
    issueCertificate.printRsaNumber = this.selectedPlan.printRsaNumber? this.selectedPlan.printRsaNumber: "No";
    issueCertificate.productRackRate = this.selectedPlan.productRackRate ? this.selectedPlan.productRackRate : 0;
    issueCertificate.operatingCost = this.selectedPlan.operatingCost ? this.selectedPlan.operatingCost : 0;
    issueCertificate.retentionCost = this.selectedPlan.retentionCost ? this.selectedPlan.retentionCost : 0;
    issueCertificate.netBenefit = this.selectedPlan.netBenefit ? this.selectedPlan.netBenefit : 0;
    if (this.selectedPlan.policyType == "FINANCE")
    {
    issueCertificate.nomineeCoverAmount = issueCertificate.planCPACoverAmount - issueCertificate.financeCoverAmount;
  }
  else
  {
    issueCertificate.nomineeCoverAmount = issueCertificate.planCPACoverAmount ;

  }
  if (!(this.selectedPlan.printCpaPolicy && this.selectedPlan.printCpaPolicy == "No") && (issueCertificate.nomineeName == "NA"))
  {
    this.alertService.error("Nominee Details invalid");
    this.loading = false;
    return;
  } 
    if (issueCertificate.registrationNumber.trim().length == 0) {
      issueCertificate.registrationNumber = "New";
      // console.log("I am here: " + issueCertificate.registrationNumber);
    }
    // else
    //    console.log("registrationNumber: " + issueCertificate.registrationNumber);
    // console.log(JSON.stringify(issueCertificate));
    this.certificateService.issueCertificate(issueCertificate)
      .pipe(first())
      .subscribe({
        next: (x) => {
          this.certificateResponse = new CertificateResponse(x);
          // console.log("CertificateResponse:" + JSON.stringify(this.certificateResponse));
          this.certficateForm.controls['certificateNumber'].setValue(this.certificateResponse.certificate.certificateNumber);
          this.certficateForm.controls['policyNumber'].setValue(this.certificateResponse.certificate.policyNumber);
          this.certficateForm.controls['balance'].setValue(this.certificateResponse.dealer.dealerBalance);
          this.dealer.dealerBalance = this.certificateResponse.dealer.dealerBalance;
          this.certificateCreated = true;

          this.alertService.success('Certificate added successfully', { keepAfterRouteChange: true });
          this.loading = false;
          this.onPdfClick();
        },
        error: error => {
          this.alertService.error(error);
          this.loading = false;
        }
      });

    return;
  }
  paymentGatewayShowToggle(){
    this.showPaymentGatewayForm = !this.showPaymentGatewayForm;
    console.log("i am here");
  }
  convertTextDate(value: NgbDateStruct) {
    if (value) {
      this.dobString = value.year.toString();
      if (value.month < 10) {
        this.dobString = this.dobString + "-0" + value.month;
      }
      else {
        this.dobString = this.dobString + "-" + value.month;
      }
      if (value.day < 10) {
        this.dobString = this.dobString + "-0" + value.day;
      }
      else {
        this.dobString = this.dobString + "-" + value.day;
      }
    }
    return this.dobString;
  }
  balanceValidator() {
    if (this.certficateForm.get('planTotalAmount').value != undefined) {
      this.runningBalance = this.dealer.dealerBalance - parseInt(this.certficateForm.get('planTotalAmount').value)
      // console.log("Dealer Balance" + this.runningBalance);

      if (this.runningBalance < this.dealer.dealerBalanceLimit) {
        this.isBalanceLow = true;
      }
      else
        this.isBalanceLow = false;
    }
  }
  onReset() {
    this.certificateCreated = false;
    this.submitted = false;
    this.alertService.clear();
    window.location.reload();
  }
  financeSelected(inputFinance:string)
  {
    this.certficateForm.controls["financeCompanyName"].setValue(inputFinance);
    this.selectedFinance = inputFinance;
  }

  onPdfClick() {
    this.certificateService.PrintCertificate = this.certificateResponse.certificate;
    this.alertService.clear();
    this.router.navigate(['../printNew'], { relativeTo: null });
  }
  maintainClientType() {
    this.certficateForm.get('clientType').valueChanges
    .subscribe(value => {
      if (value == "Individual")
      {
        this.isCorporate = false;
        this.certficateForm.controls['nomineeGender'].setValue(this.genders[1]);
        this.certficateForm.get('gender').setValidators(Validators.required);
        this.certficateForm.get('dob').setValidators(Validators.required);
        this.certficateForm.get('nomineeRelationship').setValidators(Validators.required);
        this.certficateForm.get('employeeContactNumber').clearValidators();        
        // if (this.selectedMakeModel.productType.includes('Two'))
        // {
        //   this.plans = this.twoWheelerPlans;
        // }
        // else {
        //   this.plans = this.nonTwoWheelerPlans;

        // }

      }
      else
      {
        this.isCorporate = true;
        this.certficateForm.controls['nomineeGender'].setValue(this.genders[0]);
        this.certficateForm.get('gender').clearValidators();
        this.certficateForm.get('dob').clearValidators();
        this.certficateForm.get('age').clearValidators();
        this.certficateForm.get('nomineeRelationship').clearValidators();
        this.certficateForm.get('employeeContactNumber').setValidators([Validators.required, Validators.minLength(6)]);
        // if (this.selectedMakeModel.productType.includes('Two'))
        // {
        //   this.plans = this.twoWheelerPlans.filter(x => x.policyType.includes("RSA") || x.policyType.includes("DOC"));
        // }
        // else
        // {
        //   this.plans = this.nonTwoWheelerPlans.filter(x => x.policyType.includes("RSA") || x.policyType.includes("DOC"));

        // }

      }
      this.certficateForm.controls['gender'].updateValueAndValidity();
      this.certficateForm.controls['dob'].updateValueAndValidity();
      this.certficateForm.controls['age'].updateValueAndValidity();
      this.certficateForm.controls['nomineeRelationship'].updateValueAndValidity();
      this.certficateForm.controls['employeeContactNumber'].updateValueAndValidity();
      this.filterPlanList();
      // if (this.plans.length > 0 && !this.renewCertificate)
      //   this.certficateForm.controls['planId'].setValue(this.plans[0].planId);
    });
  }

  maintainPlanValueChanges(){
    this.certficateForm.get('planId').valueChanges
      .subscribe(value => {
        if (value != undefined) {
          this.selectedPlan = this.plans.filter((x) => x.planId == value)[0];
          this.selectedPlan.numberOfYears = this.selectedPlan.numberOfYears? this.selectedPlan.numberOfYears : 1;
          //console.log(this.selectedPlan);
          if ((!this.dealarConfigFound) || this.selectedPlan.planAmount > 0)
          {
          this.certficateForm.controls['planAmount'].setValue(this.selectedPlan.planAmount);
          this.certficateForm.controls['planGSTAmount'].setValue(this.selectedPlan.planGstAmount);
          this.certficateForm.controls['planTotalAmount'].setValue(this.selectedPlan.planAmount + this.selectedPlan.planGstAmount);
          }
          else
          {
            this.certficateForm.controls['planTotalAmount'].setValue(this.selectDealerModelPrice.totalAmount - this.selectDealerModelPrice.insuranceAmount - this.f.insPolicyTotalAmount.value);
          }
          this.maxAmount = this.selectedPlan.planMaximumAmount;
          this.minAmount = this.selectedPlan.planMinimumAmount? this.selectedPlan.planMinimumAmount : this.selectedPlan.planNetAmount;
          this.certficateForm.controls['planAmount'].updateValueAndValidity();
          this.certficateForm.controls['startDate'].setValue(this.startDateModel);
          this.endDate = new Date(this.startDate);
          this.endDate = new Date(this.endDate.setFullYear(this.endDate.getFullYear() + ((this.selectedPlan.numberOfYears && this.selectedPlan.numberOfYears > 0)?this.selectedPlan.numberOfYears:1)));
          this.endDate = new Date(this.endDate.setDate(this.endDate.getDate() - 1));
          this.endDate = new Date(this.endDate.setHours(0, 0, 0, 0));
          this.certficateForm.controls['endDate'].setValue(this.endDate);
          this.certficateForm.controls['issueDate'].setValue(this.currentDate);
          this.showGstAmount = this.selectedPlan.gstApplicable ? this.selectedPlan.gstApplicable =="N" ? false : true : true; 
          this.showGstAmount = this.showGstAmount == false? false : this.selectedPlan.gstShow ? this.selectedPlan.gstShow =="N" ? false : true : true; 
          if (this.selectedPlan.policyType == "FINANCE")
          {

            this.showFinance = true;
            this.certficateForm.get('financeCompanyName').setValidators(Validators.required);
            this.certficateForm.get('financeCoverAmount').setValidators(Validators.required);
            this.selectedPlan.planCPACoverAmount = this.selectedPlan.planCPACoverAmount?this.selectedPlan.planCPACoverAmount:500000;
            this.certficateForm.get('financeCoverAmount').setValidators(Validators.max(this.selectedPlan.planCPACoverAmount));
  
          }
          else {
            this.showFinance = false;
            this.certficateForm.get('financeCompanyName').clearValidators();
            this.certficateForm.get('financeCoverAmount').clearValidators();
          }
          this.certficateForm.controls['financeCompanyName'].updateValueAndValidity();
          this.certficateForm.controls['financeCoverAmount'].updateValueAndValidity();
          this.maintainNomineeValidators();
    
        }

          if (this.selectedPlan.planAmount == 0) {
            this.certficateForm.controls['planTotalAmount'].enable();
        }
        else {
          this.certficateForm.controls['planTotalAmount'].disable();
        }
      });

    this.certficateForm.get('planTotalAmount').valueChanges
      .subscribe(value => {
        if (value != undefined) {
            if (this.selectedPlan.planAmount == 0) {
              this.planTotalAmount = parseInt(value);
            this.planAmount = (this.planTotalAmount / (1 + this.gstPercentage)).toFixed(2);
            this.planGSTAmount = (this.planTotalAmount - this.planAmount).toFixed(2);
            this.minAmount = this.selectedPlan.planMinimumAmount? this.selectedPlan.planMinimumAmount :1000;
            this.certficateForm.controls['planGSTAmount'].setValue(this.planGSTAmount);
            this.certficateForm.controls['planAmount'].setValue(this.planAmount);
            this.balanceValidator();
          }
        }
      });

  }
  maintainNomineeValidators() {
    // Preserve existing nominee values before making changes
    const existingNomineeName = this.certficateForm.controls['nomineeName'].value;
    const existingNomineeRelationship = this.certficateForm.controls['nomineeRelationship'].value;
    const existingNomineeGender = this.certficateForm.controls['nomineeGender'].value;
    const existingNomineeAge = this.certficateForm.controls['nomineeAge'].value;
    
    if (this.selectedPlan.printCpaPolicy && this.selectedPlan.printCpaPolicy=="No") {
        this.certficateForm.controls['nomineeGender'].setValue("NA");
          this.certficateForm.controls['nomineeRelationship'].setValue("NA");
          this.certficateForm.controls['nomineeName'].setValue("NA");
          this.certficateForm.controls['nomineeAge'].setValue(99);
          this.certficateForm.get('employeeContactNumber').clearValidators();
        }
        else
        {
          // Only reset if fields are empty, otherwise preserve existing values
          if (!existingNomineeGender || existingNomineeGender === '') {
            this.certficateForm.controls['nomineeGender'].setValue(this.genders[1]);
          }
          if (!existingNomineeRelationship || existingNomineeRelationship === '') {
            this.certficateForm.controls['nomineeRelationship'].setValue(this.relationships[0]);
          }
          // Preserve nominee name and age if they exist
          if (!existingNomineeName || existingNomineeName === '') {
            this.certficateForm.controls['nomineeName'].setValue("");
          }
          if (!existingNomineeAge || existingNomineeAge === 0 || existingNomineeAge === null || existingNomineeAge === undefined) {
            this.certficateForm.controls['nomineeAge'].reset();
          }
          if (this.isCorporate){
          this.certficateForm.get('employeeContactNumber').setValidators([Validators.required, Validators.minLength(6)]);
          }
          else
         {
            this.certficateForm.get('employeeContactNumber').clearValidators();
          }

        }
        this.certficateForm.controls['employeeContactNumber'].updateValueAndValidity();

    // }
  
  }
  maintainDateTimeValueChanges() {
    this.certficateForm.get('startDate').valueChanges
    .subscribe(value =>{
      if (value != undefined){
        if(value.month != undefined && value.day != undefined && value.year != undefined){
            this.startDate = new Date(this.convertTextDate(value));
            if (parseInt(value.month) == (this.currentDate.getMonth() + 1) && parseInt(value.day) == this.currentDate.getDate() && parseInt(value.year) == this.currentDate.getFullYear())
            this.startDate = new Date(this.currentDate);
            else
            this.startDate = new Date(this.startDate.setHours(0, 0, 0, 0));


            this.endDate = new Date(this.startDate);
            this.endDate = new Date(this.endDate.setFullYear(this.endDate.getFullYear() + ((this.selectedPlan.numberOfYears && this.selectedPlan.numberOfYears > 0)?this.selectedPlan.numberOfYears:1)));
            this.endDate = new Date(this.endDate.setDate(this.endDate.getDate() - 1));
            this.endDate = new Date(this.endDate.setHours(0, 0, 0, 0));
            this.certficateForm.controls['endDate'].setValue(this.endDate);
            this.certficateForm.controls['issueDate'].setValue(this.startDate);
            this.issueDate = this.startDate;
                      }
      }

    });
    this.certficateForm.get('dob').valueChanges
    .subscribe(value => {
    if (value && value.year && value.year != 1001)
    {
      this.certficateForm.controls['age'].setValue(this.currentDate.getFullYear() - parseInt(value.year));
    }
    });
    this.certficateForm.get('type').valueChanges
    .subscribe(value => {
      this.dealerConfig = this.allDealerConfig.find(a=>[undefined,"Both",value].includes(a.applicableOn));
      if (this.dealerConfig && this.dealerConfig.dealerModelPrices.length > 0) {
        this.dealarConfigFound = true;
        this.getMakeModelFromDealerConfig();
      } else {
        this.dealarConfigFound = false;
        this.setDefaultMakeModel();
      }

      if (value == "Old") {
        this.certficateForm.controls['vehicleYear'].setValue(this.currentDate.getFullYear());
        this.certficateForm.get('registrationNumber').setValidators(Validators.required);
        this.years = [this.currentDate.getFullYear(), this.currentDate.getFullYear() - 1
          , this.currentDate.getFullYear() - 2
          , this.currentDate.getFullYear() - 3
          , this.currentDate.getFullYear() - 4
          , this.currentDate.getFullYear() - 5
          , this.currentDate.getFullYear() - 6
          , this.currentDate.getFullYear() - 7
          , this.currentDate.getFullYear() - 8
          , this.currentDate.getFullYear() - 9
          , this.currentDate.getFullYear() - 10
          , this.currentDate.getFullYear() - 11
          , this.currentDate.getFullYear() - 12
          , this.currentDate.getFullYear() - 13
          , this.currentDate.getFullYear() - 14
        ];
        this.certficateForm.controls['startDate'].enable();
        this.maxDateModel = this.oldMaxDateModel;
      }

      else {
        this.maxDateModel = this.newMaxDateModel;
        this.years = [this.currentDate.getFullYear(), this.currentDate.getFullYear() - 1, this.currentDate.getFullYear() - 2];
        this.certficateForm.get('registrationNumber').clearValidators();
        // this.certficateForm.controls['startDate'].disable();
      }
      this.filterPlanList();
      this.certficateForm.controls['registrationNumber'].updateValueAndValidity();
      this.certficateForm.controls['startDate'].updateValueAndValidity();
      if (!this.renewCertificate) this.certficateForm.controls['vehicleYear'].setValue(this.years[0]);
    });
}

maintainModelandMakeValueChanges(){
  this.certficateForm.get('model').valueChanges
  .subscribe(value => {
    if (value == "Others") {
      this.certficateForm.get('variant').setValidators(Validators.required);
    }
    else {
      this.certficateForm.get('variant').clearValidators();
    }
    this.certficateForm.controls['variant'].updateValueAndValidity();
    if (this.dealarConfigFound){
      this.selectDealerModelPrice = this.dealerConfig.dealerModelPrices.find(a => a.model == value);
      if (this.selectDealerModelPrice && this.selectDealerModelPrice.heroVariant) {
        this.f.variant.setValue(this.selectDealerModelPrice.heroVariant);
      }
      if (this.selectDealerModelPrice) {
        this.selectDealerModelPrice.insuranceAmount = this.selectDealerModelPrice.insuranceAmount ?this.selectDealerModelPrice.insuranceAmount:0;
        this.f.insPolicyTotalAmount.setValue(this.selectDealerModelPrice.insuranceAmount);
        console.log("Insurance Amount: " + JSON.stringify(this.selectDealerModelPrice));
        this.f.planTotalAmount.setValue(this.selectDealerModelPrice.allianceAmount);
        const zeroAmountPlan = this.plans.find(a => a.planAmount == 0);
        if (zeroAmountPlan) {
          this.f.planId.setValue(zeroAmountPlan.planId);
        }
      }
    }
  });
  this.certficateForm.get('vehicleMake').valueChanges.subscribe((value) => {
    if (value != undefined) {
      if (this.dealarConfigFound)
        {
          this.selectedMakeModel = this.makeModel.find(a => a.make == value);
          this.certficateForm.controls['vehicleType'].setValue(this.selectedMakeModel.productType);
        this.models =  this.selectedMakeModel.model;
        this.filterPlanList();

        }
        else {
      this.configDataService.MakeModel$.subscribe(
        (x) => {this.selectedMakeModel = x.find(a => a.make == value);
          this.certficateForm.controls['vehicleType'].setValue(this.selectedMakeModel.productType);
        this.models =  this.selectedMakeModel.model;
        // if (this.selectedMakeModel.productType.includes("Two"))
        // {
        //  this.plans = this.twoWheelerPlans;   
        // }
        // else
        // {
        //   this.plans = this.nonTwoWheelerPlans;   

        // }
        // if (this.plans.length > 0 && !this.renewCertificate)
        // this.certficateForm.controls['planId'].setValue(this.plans[0].planId);
        this.filterPlanList();

        }
        
      )
    }
    }
  });
  this.certficateForm.get('insPolicyTotalAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.insPolicyTotalAmount = parseInt(value);
      this.insPolicyAmount = parseFloat((this.insPolicyTotalAmount / (1 + this.gstPercentage)).toFixed(2));
      this.certficateForm.controls['insPolicyGStAmount'].setValue(parseFloat((this.insPolicyTotalAmount - this.insPolicyAmount).toFixed(2)))
      this.certficateForm.controls['insPolicyAmount'].setValue(this.insPolicyAmount)
      if(this.dealarConfigFound)
      {
      this.certficateForm.controls['planTotalAmount'].setValue(this.selectDealerModelPrice.totalAmount - this.insPolicyTotalAmount);
    }
    }
  });
  this.certficateForm.get('insPolicyAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.certficateForm.controls['packageAmount'].setValue(parseFloat(value) + parseFloat(this.certficateForm.get('planAmount').value))
    }
  });
  this.certficateForm.get('insPolicyGStAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.certficateForm.controls['packageGstAmount'].setValue(parseFloat(value) + parseFloat(this.certficateForm.get('planGSTAmount').value))
    }
  });
  this.certficateForm.get('planAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.certficateForm.controls['packageAmount'].setValue(parseFloat((parseFloat(value) + parseFloat(this.certficateForm.get('insPolicyAmount').value)).toFixed(2)))
    }
  });
  this.certficateForm.get('planGSTAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.certficateForm.controls['packageGstAmount'].setValue(parseFloat((parseFloat(value) + parseFloat(this.certficateForm.get('insPolicyGStAmount').value)).toFixed(2)))
    }
  });
  this.certficateForm.get('packageAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.certficateForm.controls['packageTotalAmount'].setValue(parseFloat(parseInt(value + this.certficateForm.get('packageGstAmount').value).toFixed(2)))
    }
  });
  this.certficateForm.get('packageGstAmount').valueChanges
  .subscribe(value =>{
    if (value){
      this.certficateForm.controls['packageTotalAmount'].setValue(parseFloat(parseInt(value + this.certficateForm.get('packageAmount').value).toFixed(2)))
    }
  });

}
maintainMiscValueChanges(){
  this.certficateForm.get('financeCompanyName').valueChanges.subscribe((value) => {
    if (value){
      this.nameRegexp = new RegExp(value,'i'); 
      this.selectedFinanceCompanies = this.financeCompanies.filter(a => {
      return this.nameRegexp.test(a);
    })}
    else
    this.selectedFinanceCompanies = [];
 });

 this.certficateForm.get('ageOrDob').valueChanges.subscribe((value) => {
  if (value != undefined) {
    if (value == this.ageOrDobValue[1])
    {
      // this.certficateForm.get('age').setValidators([Validators.required,Validators.min(18),Validators.max(80)]);
      this.certficateForm.get('age').setValue(24);
      // this.certficateForm.get('age').setValidators(Validators.max(80));
      this.certficateForm.get('dob').clearValidators(); 
      this.minDobDateModel.year  = 1001;         
      this.minDobDateModel.month  = 1;         
      this.minDobDateModel.day  = 1;         
      this.certficateForm.controls['dob'].setValue(this.minDobDateModel);

    }
    else
    {
      {
        this.maxDobDateModel.year = this.maxDobDate.getFullYear();
        this.maxDobDateModel.day = this.maxDobDate.getDate();
        this.maxDobDateModel.month = this.maxDobDate.getMonth() + 1;
            this.certficateForm.controls['dob'].setValue(this.maxDobDateModel);
            this.minDobDateModel.year = this.minDobDate.getFullYear();
            this.minDobDateModel.day = this.minDobDate.getDate();
            this.minDobDateModel.month = this.minDobDate.getMonth() + 1;
                this.certficateForm.controls['dob'].setValue(this.minDobDateModel);
            this.certficateForm.get('dob').setValidators(Validators.required);
        this.certficateForm.get('age').clearValidators(); 
      }  
    }
    this.certficateForm.get('age').updateValueAndValidity(); 
    this.certficateForm.get('dob').updateValueAndValidity(); 
  }
});

this.certficateForm.get('state').valueChanges.subscribe((value) => {
  if (value != undefined) {
    this.configDataService.StateCity$.subscribe(
      (x) => {
        const stateCityData = x.find(a => a.state == value);
        if (stateCityData) {
          this.cities = stateCityData.city;
        }
      }
    )
  }
})
}
filterPlanList(){
  if (!this.plans) return;

  var filteredPlan = this.dealer.dealerPlan;
  if (this.selectedMakeModel)
  {
        if (this.selectedMakeModel.productType.includes("Two"))
        {
          filteredPlan = this.dealer.dealerPlan.filter(x => !x.policyType.includes('(CAR)'));;   
        }
        else
        {
          filteredPlan = this.dealer.dealerPlan.filter(x => x.policyType.includes('(CAR)'));;   
  
        }
  }
  if (this.certficateForm.get('type').value == this.types[0])
  {
    filteredPlan = filteredPlan.filter(x => !(x.applicableOnlyOnPolicyType && x.applicableOnlyOnPolicyType == this.types[1]));
  }
  if (this.certficateForm.get('type').value == this.types[1])
  {
    filteredPlan = filteredPlan.filter(x => !(x.applicableOnlyOnPolicyType && x.applicableOnlyOnPolicyType == this.types[0]));
  }
  if (this.dealarConfigFound)
  {
    filteredPlan = filteredPlan.sort((x,y) => x.planAmount < y.planAmount ? -1 : 1);
  }
  this.plans = filteredPlan;
  if (this.plans.length > 0 && !this.renewCertificate) {
  this.certficateForm.controls['planId'].setValue(this.plans[0].planId);
};


}

// PDF Upload Panel Event Handlers
onPdfDataExtracted(extractedData: ExtractedData): void {
  console.log('PDF data extracted:', extractedData);
  // Auto-populate form immediately
  this.populateFormFromExtractedData(extractedData);
  this.alertService.success('Data extracted from PDF and form auto-populated!');
}

onFormPopulated(result: PopulationResult): void {
  console.log('Form populated:', result);
  // Show success message with statistics
  const stats = result.statistics;
  const message = `Form auto-populated successfully! ${stats.populated} fields filled, ${stats.skipped} skipped.`;
  this.alertService.success(message);
}

/**
 * Populate form from extracted PDF data
 */
populateFormFromExtractedData(extractedData: ExtractedData): void {
  if (!extractedData) return;

  // Store original field values before population
  this.trackOriginalFieldValues();

  // Handle model prepopulation - check if model field is already extracted
  if (extractedData.model?.value) {
    // Model field is already extracted from makeModel, populate it directly
    this.populateFieldIfAvailable(extractedData.model, 'model');
  } else if (extractedData.vehicleMake?.value) {
    // Fallback: vehicleMake from PDF contains both make and model, process it
    this.handleModelPrepopulation(extractedData.vehicleMake.value);
  }

  // Handle vehicle year and type
  if (extractedData.vehicleYear?.value) {
    this.handleVehicleYearAndType(extractedData.vehicleYear.value);
  }

  // Direct field population
  this.populateFieldIfAvailable(extractedData.registrationNumber, 'registrationNumber');
  this.populateFieldIfAvailable(extractedData.chasisNumber, 'chasisNumber');
  this.populateFieldIfAvailable(extractedData.engineNumber, 'engineNumber');
  this.populateFieldIfAvailable(extractedData.firstName, 'firstName');
  this.populateFieldIfAvailable(extractedData.address, 'address');
  this.populateFieldIfAvailable(extractedData.nomineeName, 'nomineeName');
  this.populateFieldIfAvailable(extractedData.nomineeRelationship, 'nomineeRelationship');
  this.populateFieldIfAvailable(extractedData.nomineeAge, 'nomineeAge');

  // Populate state and city from dealer if not already populated from PDF
  if (!extractedData.state?.value) {
    this.populateStateCityFromDealer();
  } else {
    // If state is populated from PDF, still populate city from dealer if city is not in PDF
    if (!extractedData.city?.value) {
      this.populateCityFromDealer();
    }
  }

  // Guess nominee gender based on gender and nomineeRelationship
  this.guessAndSetNomineeGender();

  // Highlight required fields
  this.highlightRequiredFields();
}

/**
 * Helper method to populate a field if available
 * Always overwrites on new upload (no matter if field is populated or not)
 */
private populateFieldIfAvailable(extractedField: any, formFieldName: string): void {
  if (extractedField?.value && this.certficateForm.get(formFieldName)) {
    const extractedValue = extractedField.value.trim();
    // Always populate/overwrite on new upload
    if (extractedValue && extractedValue !== '') {
      // Mark as auto-populated before setting value
      this.autoPopulatedFields.add(formFieldName);
      this.certficateForm.get(formFieldName)?.setValue(extractedValue, { emitEvent: false });
      this.modifiedFields.add(formFieldName);
      // Remove from manually filled if it was there
      this.manuallyFilledFields.delete(formFieldName);
    }
  }
}

/**
 * Handle model prepopulation with fuzzy matching
 */
handleModelPrepopulation(modelName: string): void {
  if (!modelName || !modelName.trim() || !this.makeModel || this.makeModel.length === 0) {
    return;
  }

  const trimmedModelName = modelName.trim();

  // Check if model exists in current models array
  const currentMake = this.certficateForm.get('vehicleMake')?.value;
  if (currentMake && this.models && this.models.length > 0) {
    const modelExists = this.models.some(m => m && m.toLowerCase().trim() === trimmedModelName.toLowerCase());
    if (modelExists) {
      // Find the exact matching model from the array (preserving case if needed)
      const exactModel = this.models.find(m => m && m.toLowerCase().trim() === trimmedModelName.toLowerCase());
      if (exactModel) {
        this.certficateForm.get('model')?.setValue(exactModel);
        this.modifiedFields.add('model');
        this.autoPopulatedFields.add('model');
        return;
      }
    }
  }

  // Model doesn't exist - use fuzzy matching to find closest match
  // Only proceed if similarity is >= 60%
  const matchResult = this.commonFunctionService.findClosestModelMatch(trimmedModelName, this.makeModel);
  
  // Only prepopulate if match result exists (similarity >= 60%)
  if (matchResult) {
    // Mark as auto-populated before setting values
    this.autoPopulatedFields.add('vehicleMake');
    this.autoPopulatedFields.add('model');
    
    // Update the makeModel array with new model
    if (this.makeModel[matchResult.matchedMakeIndex]) {
      this.makeModel[matchResult.matchedMakeIndex].model = matchResult.updatedModelArray;
    }

    // Set the vehicleMake to the matched make
    this.certficateForm.get('vehicleMake')?.setValue(matchResult.make, { emitEvent: false });
    this.modifiedFields.add('vehicleMake');
    this.manuallyFilledFields.delete('vehicleMake');

    // Update models array for the selected make
    this.selectedMakeModel = this.makeModel.find(m => m.make === matchResult.make);
    if (this.selectedMakeModel) {
      this.models = this.selectedMakeModel.model;
    }

    // Set the model - use trimmedModelName to ensure no spaces
    this.certficateForm.get('model')?.setValue(trimmedModelName, { emitEvent: false });
    this.modifiedFields.add('model');
    this.manuallyFilledFields.delete('model');

    // Trigger make change handlers
    if (this.selectedMakeModel) {
      this.certficateForm.controls['vehicleType'].setValue(this.selectedMakeModel.productType);
    }
    this.filterPlanList();
  } else {
    // No match found with >= 60% similarity - don't prepopulate
    console.log(`Model "${trimmedModelName}" did not match any existing model with >= 60% similarity. Skipping model prepopulation.`);
  }
}

/**
 * Handle vehicle year and type logic
 */
handleVehicleYearAndType(vehicleYear: string | number): void {
  if (!vehicleYear) return;

  // Extract numeric value from string if needed
  const yearString = typeof vehicleYear === 'string' ? vehicleYear.trim().replace(/[^\d]/g, '') : vehicleYear.toString();
  const yearValue = typeof vehicleYear === 'string' ? parseInt(yearString, 10) : vehicleYear;
  
  // Validate year is numeric and reasonable
  if (isNaN(yearValue) || yearValue < 1900 || yearValue > this.currentDate.getFullYear() + 1) {
    return;
  }

  const currentYear = this.currentDate.getFullYear();
  const yearDifference = currentYear - yearValue;

  // Mark as auto-populated before setting values
  this.autoPopulatedFields.add('type');
  this.autoPopulatedFields.add('vehicleYear');

  // If difference >= 2 years, set type as "Old", else "New"
  if (yearDifference >= 2) {
    this.certficateForm.get('type')?.setValue('Old', { emitEvent: false });
  } else {
    this.certficateForm.get('type')?.setValue('New', { emitEvent: false });
  }
  this.modifiedFields.add('type');
  this.manuallyFilledFields.delete('type');

  // Populate vehicleYear
  this.certficateForm.get('vehicleYear')?.setValue(yearValue, { emitEvent: false });
  this.modifiedFields.add('vehicleYear');
  this.manuallyFilledFields.delete('vehicleYear');
}

/**
 * Guess nominee gender based on gender and nomineeRelationship
 */
guessNomineeGender(): string | null {
  const gender = this.certficateForm.get('gender')?.value;
  let nomineeRelationship = this.certficateForm.get('nomineeRelationship')?.value;

  // Trim and normalize relationship value
  if (nomineeRelationship) {
    nomineeRelationship = nomineeRelationship.trim();
  }

  // Need relationship to guess gender
  if (!nomineeRelationship || nomineeRelationship === 'NA' || nomineeRelationship === '' || nomineeRelationship === 'Other') {
    return null;
  }

  // Relationship-based gender rules (case-insensitive lookup)
  const relationshipGenderMap: { [key: string]: string } = {
    'wife': 'Female',
    'husband': 'Male',
    'father': 'Male',
    'mother': 'Female',
    'son': 'Male',
    'daughter': 'Female',
    'brother': 'Male',
    'sister': 'Female',
    'grandson': 'Male',
    'granddaughter': 'Female'
  };

  // Special case for Spouse - depends on customer gender
  let guessedGender: string | null = null;
  const relationshipLower = nomineeRelationship.toLowerCase();
  
  if (relationshipLower === 'spouse') {
    // For Spouse, need customer gender to determine opposite gender
    if (gender) {
      const genderLower = gender.toString().toLowerCase();
      if (genderLower === 'male') {
        guessedGender = 'Female';
      } else if (genderLower === 'female') {
        guessedGender = 'Male';
      }
    }
    // If customer gender is not set, can't determine spouse gender
    if (!guessedGender) {
      return null;
    }
  } else {
    // Look up in map (case-insensitive)
    guessedGender = relationshipGenderMap[relationshipLower] || null;
  }
  
  // If we couldn't guess a gender, return null
  if (!guessedGender) {
    return null;
  }
  
  // Map to form values (form might use "Male"/"Female" or other values)
  // Check what values the form actually uses
  if (this.genders && this.genders.length > 0) {
    // Find matching gender value (case-insensitive)
    const matchedGender = this.genders.find(g => 
      g.toString().toLowerCase() === guessedGender.toLowerCase()
    );
    return matchedGender || guessedGender;
  }
  
  return guessedGender;
}

/**
 * Guess and set nominee gender
 * This method is called whenever gender or nomineeRelationship changes
 * It should always update the nominee gender based on the relationship rules
 */
guessAndSetNomineeGender(): void {
  const guessedGender = this.guessNomineeGender();
  const nomineeGenderControl = this.certficateForm.get('nomineeGender');
  
  if (!nomineeGenderControl) {
    return;
  }
  
  const currentValue = nomineeGenderControl.value;
  
  // If we can't guess a gender (e.g., relationship is "Other" or not set), don't update
  if (!guessedGender) {
    // If current value is set and valid, keep it (don't clear it)
    // Only clear if it was auto-populated and now we can't guess
    if (this.autoPopulatedFields.has('nomineeGender') && (!currentValue || currentValue === 'NA')) {
      // Keep the field as is - don't clear it
    }
    return;
  }
  
  // Always update if we can guess a gender, regardless of current state
  // This ensures that when gender or relationship changes, nominee gender is recalculated
  // Only exception: if user just manually set it in this same change cycle (handled by trackManualFieldChanges)
  
  // Check if we need to update (different value or empty)
  if (!currentValue || currentValue === 'NA' || currentValue !== guessedGender) {
    // Mark as auto-populated (it's being calculated by the system)
    this.autoPopulatedFields.add('nomineeGender');
    nomineeGenderControl.setValue(guessedGender, { emitEvent: false });
    this.modifiedFields.add('nomineeGender');
    // Remove from manually filled since we're auto-updating it based on rules
    this.manuallyFilledFields.delete('nomineeGender');
  } else {
    // Value already matches, but ensure it's marked as auto-populated
    // This happens when the guessed value is already set correctly
    if (this.autoPopulatedFields.has('nomineeGender')) {
      // Already correct and auto-populated, no change needed
      this.manuallyFilledFields.delete('nomineeGender');
    }
  }
}

/**
 * Subscribe to gender and nomineeRelationship changes for nominee gender guessing
 * This ensures nominee gender is automatically recalculated whenever these values change
 */
subscribeToNomineeGenderChanges(): void {
  // Subscribe to gender changes
  const genderControl = this.certficateForm.get('gender');
  if (genderControl) {
    genderControl.valueChanges.subscribe(() => {
      // Use a small delay to ensure the form control value has updated
      setTimeout(() => {
        console.log('[Nominee Gender] Gender changed, recalculating nominee gender...');
        this.guessAndSetNomineeGender();
      }, 100);
    });
  }

  // Subscribe to nomineeRelationship changes
  const nomineeRelationshipControl = this.certficateForm.get('nomineeRelationship');
  if (nomineeRelationshipControl) {
    nomineeRelationshipControl.valueChanges.subscribe(() => {
      // Use a small delay to ensure the form control value has updated
      setTimeout(() => {
        console.log('[Nominee Gender] Relationship changed, recalculating nominee gender...');
        this.guessAndSetNomineeGender();
      }, 100);
    });
  }
}

/**
 * Track original field values before population
 */
trackOriginalFieldValues(): void {
  // Don't clear manually filled fields - preserve them
  // this.modifiedFields.clear();
  this.autoPopulatedFields.clear();
}

/**
 * Highlight required fields
 * Checks for Validators.required in the validator function
 */
highlightRequiredFields(): void {
  this.requiredFields.clear();
  
  Object.keys(this.certficateForm.controls).forEach(key => {
    const control = this.certficateForm.get(key);
    if (control) {
      // Check if control has required validator
      // Method 1: Check if validator function exists and returns required error
      const validators = control.validator;
      if (validators) {
        const validationResult = validators({} as AbstractControl);
        if (validationResult && validationResult['required']) {
          this.requiredFields.add(key);
        }
      }
      
      // Method 2: Check if validators array contains Validators.required
      // Some validators are set as arrays
      const controlAny = control as any;
      if (controlAny._rawValidators) {
        const rawValidators = controlAny._rawValidators;
        if (Array.isArray(rawValidators)) {
          const hasRequired = rawValidators.some((validator: any) => {
            if (validator === Validators.required) return true;
            // Check if validator is a function that returns required error
            if (typeof validator === 'function') {
              const result = validator({} as AbstractControl);
              return result && result['required'];
            }
            return false;
          });
          if (hasRequired) {
            this.requiredFields.add(key);
          }
        } else if (rawValidators === Validators.required) {
          this.requiredFields.add(key);
        } else if (typeof rawValidators === 'function') {
          const result = rawValidators({} as AbstractControl);
          if (result && result['required']) {
            this.requiredFields.add(key);
          }
        }
      }
      
      // Method 3: Check if validator is part of a composite validator (like in an array)
      // Check validators set during form creation
      const controlValidators = (control as any).validator;
      if (controlValidators) {
        // Try with empty control to see if required error appears
        const emptyControl = this.formBuilder.control('');
        if (controlValidators(emptyControl) && controlValidators(emptyControl)['required']) {
          this.requiredFields.add(key);
        }
      }
    }
  });
  
  // Manually add known required fields based on form definition
  const knownRequiredFields = [
    'vehicleMake', 'model', 'type', 'chasisNumber', 'engineNumber', 
    'clientType', 'firstName', 'contactNumber', 'gender', 'dob', 
    'address', 'state', 'city', 'nomineeName', 'nomineeRelationship', 
    'nomineeGender', 'nomineeAge', 'planId', 'planTotalAmount', 'startDate'
  ];
  
  knownRequiredFields.forEach(fieldName => {
    if (this.certficateForm.get(fieldName)) {
      this.requiredFields.add(fieldName);
    }
  });
  
  // Add conditional required fields
  if (!this.isCorporate && this.certficateForm.get('employeeContactNumber')) {
    // employeeContactNumber might be conditionally required
  }
  
  if (this.isCorporate && this.certficateForm.get('employeeContactNumber')) {
    this.requiredFields.add('employeeContactNumber');
  }
  
  // Add age if ageOrDob is set to age
  if (this.certficateForm.get('ageOrDob')?.value === this.ageOrDobValue[1]) {
    if (this.certficateForm.get('age')) {
      this.requiredFields.add('age');
    }
  }
  
  // Add amounts that are required (even if value is 0)
  // These fields might have 0 values but are still required
  const amountFields = ['planTotalAmount'];
  amountFields.forEach(fieldName => {
    const control = this.certficateForm.get(fieldName);
    if (control) {
      // Check if field has required validator
      const validators = control.validator;
      if (validators) {
        const result = validators({} as AbstractControl);
        if (result && result['required']) {
          this.requiredFields.add(fieldName);
        }
      }
      // Also check _rawValidators for required
      const controlAny = control as any;
      if (controlAny._rawValidators) {
        const rawValidators = controlAny._rawValidators;
        if (Array.isArray(rawValidators)) {
          const hasRequired = rawValidators.some((validator: any) => {
            return validator === Validators.required;
          });
          if (hasRequired) {
            this.requiredFields.add(fieldName);
          }
        } else if (rawValidators === Validators.required) {
          this.requiredFields.add(fieldName);
        }
      }
    }
  });
  
  // Call again after form state changes to catch dynamic validators
  setTimeout(() => {
    // Re-check for any validators that might have been set dynamically
    Object.keys(this.certficateForm.controls).forEach(key => {
      const control = this.certficateForm.get(key);
      if (control) {
        const validators = control.validator;
        if (validators) {
          const validationResult = validators({} as AbstractControl);
          if (validationResult && validationResult['required']) {
            this.requiredFields.add(key);
          }
        }
      }
    });
  }, 100);
}

/**
 * Check if a field is modified (auto-populated)
 */
isFieldModified(fieldName: string): boolean {
  return this.modifiedFields.has(fieldName);
}

/**
 * Check if a field is required
 */
isFieldRequired(fieldName: string): boolean {
  return this.requiredFields.has(fieldName);
}

/**
 * Check if a field is empty or zero (for required fields)
 */
isFieldEmptyOrZero(fieldName: string): boolean {
  const control = this.certficateForm.get(fieldName);
  if (!control) return false;
  
  const value = control.value;
  
  // Check if empty, null, undefined, or empty string
  if (value === null || value === undefined || value === '') {
    return true;
  }
  
  // Check if zero for numeric fields
  if (typeof value === 'number' && value === 0) {
    return true;
  }
  
  // Check if it's a date picker with invalid date
  if (value && typeof value === 'object' && value.year === 1001) {
    return true;
  }
  
  return false;
}

/**
 * Check if a field is manually filled
 */
isFieldManuallyFilled(fieldName: string): boolean {
  return this.manuallyFilledFields.has(fieldName);
}

/**
 * Track manual field changes (when user manually edits fields)
 */
trackManualFieldChanges(): void {
  // Subscribe to all form control changes to detect manual edits
  Object.keys(this.certficateForm.controls).forEach(key => {
    const control = this.certficateForm.get(key);
    if (control) {
      // Skip tracking for nomineeGender since it's handled specially
      if (key === 'nomineeGender') {
        return;
      }
      
      control.valueChanges.subscribe(() => {
        // If field was not auto-populated, mark as manually filled
        // Use a small delay to allow auto-population flag to be set first
        setTimeout(() => {
          if (!this.autoPopulatedFields.has(key)) {
            const value = control.value;
            if (value !== null && value !== undefined && value !== '' && 
                (typeof value !== 'number' || value !== 0)) {
              // Check if it's not a date picker with invalid date
              if (!(value && typeof value === 'object' && value.year === 1001)) {
                this.manuallyFilledFields.add(key);
                this.modifiedFields.add(key);
              }
            }
          } else {
            // If field was auto-populated but user manually changed it, mark as manually filled
            // and remove from auto-populated
            this.manuallyFilledFields.add(key);
            this.autoPopulatedFields.delete(key);
          }
        }, 100);
      });
    }
  });
  
  // Special handling for nomineeGender - track manual changes
  // This needs to be aware that auto-updates happen when gender/relationship changes
  const nomineeGenderControl = this.certficateForm.get('nomineeGender');
  if (nomineeGenderControl) {
    nomineeGenderControl.valueChanges.subscribe(() => {
      // Use a longer delay to distinguish between auto-updates and manual changes
      // Auto-updates use setTimeout(100ms), so we check after 200ms to see final state
      setTimeout(() => {
        // Only mark as manually filled if it's not in autoPopulatedFields
        // If the system auto-updated it, it will be in autoPopulatedFields
        if (!this.autoPopulatedFields.has('nomineeGender')) {
          const value = nomineeGenderControl.value;
          // Only mark as manual if there's a valid value and it wasn't auto-populated
          if (value !== null && value !== undefined && value !== '' && value !== 'NA') {
            this.manuallyFilledFields.add('nomineeGender');
            this.modifiedFields.add('nomineeGender');
            console.log('[Nominee Gender] Field marked as manually filled by user');
          }
        } else {
          // Was auto-populated, ensure it's not marked as manual
          this.manuallyFilledFields.delete('nomineeGender');
        }
      }, 200); // Longer delay than auto-update to check final state
    });
  }
}

/**
 * Get field CSS classes for highlighting
 */
getFieldClasses(fieldName: string, includeInvalid: boolean = false): { [key: string]: boolean } {
  const isRequired = this.isFieldRequired(fieldName);
  const isEmptyZero = isRequired && this.isFieldEmptyOrZero(fieldName);
  const isManuallyFilled = this.isFieldManuallyFilled(fieldName);
  const isAutoPopulated = this.autoPopulatedFields.has(fieldName);
  const control = this.certficateForm.get(fieldName);
  
  // Priority: manually filled (green) > auto-populated (yellow) > empty required (red)
  const classes: { [key: string]: boolean } = {
    'field-required': isRequired,
    'field-empty-zero': isEmptyZero,
    // Yellow for auto-populated fields (unless manually filled)
    'field-modified': isAutoPopulated && !isManuallyFilled,
    // Green for manually filled fields (only if not auto-populated, or if user overrode)
    'field-manually-filled': isManuallyFilled && !isAutoPopulated
  };
  
  if (includeInvalid && control) {
    classes['is-invalid'] = this.submitted && !!control.errors;
  }
  
  return classes;
}

/**
 * Populate state and city from dealer data if available
 */
populateStateCityFromDealer(): void {
  if (!this.dealer) return;

      // Populate state if dealer has state and form field is empty
  if (this.dealer.dealerState && this.dealer.dealerState.trim()) {
    const currentState = this.certficateForm.get('state')?.value;
    if (!currentState || currentState === '') {
      this.autoPopulatedFields.add('state');
      this.certficateForm.get('state')?.setValue(this.dealer.dealerState, { emitEvent: false });
      this.modifiedFields.add('state');
      this.manuallyFilledFields.delete('state');
      
      // Load cities for the selected state
      this.configDataService.StateCity$.subscribe((x) => {
        const stateCityData = x.find(a => a.state == this.dealer.dealerState);
        if (stateCityData) {
          this.cities = stateCityData.city;
          
          // Populate city if dealer has city and form field is empty
          if (this.dealer.dealerCity && this.dealer.dealerCity.trim()) {
            const currentCity = this.certficateForm.get('city')?.value;
            if (!currentCity || currentCity === '') {
              // Check if dealer city exists in the cities list
              const cityExists = this.cities.some(c => c === this.dealer.dealerCity);
              if (cityExists) {
                this.autoPopulatedFields.add('city');
                this.certficateForm.get('city')?.setValue(this.dealer.dealerCity, { emitEvent: false });
                this.modifiedFields.add('city');
                this.manuallyFilledFields.delete('city');
              }
            }
          }
        }
      });
    } else {
      // State already has value, but check if we need to populate city
      this.populateCityFromDealer();
    }
  }
}

/**
 * Populate city from dealer data if available (when state is already set)
 */
populateCityFromDealer(): void {
  if (!this.dealer || !this.dealer.dealerCity) return;

  const currentCity = this.certficateForm.get('city')?.value;
  if (!currentCity || currentCity === '') {
    const currentState = this.certficateForm.get('state')?.value;
    
    // If state matches dealer state, populate city
    if (currentState === this.dealer.dealerState) {
      // Ensure cities are loaded for current state
      if (!this.cities || this.cities.length === 0) {
        this.configDataService.StateCity$.subscribe((x) => {
          const stateCityData = x.find(a => a.state == currentState);
          if (stateCityData) {
            this.cities = stateCityData.city;
            this.setCityIfExists();
          }
        });
      } else {
        this.setCityIfExists();
      }
    }
  }
}

/**
 * Helper method to set city if it exists in cities list
 */
private setCityIfExists(): void {
  if (this.dealer.dealerCity && this.dealer.dealerCity.trim()) {
    const cityExists = this.cities && this.cities.some(c => c === this.dealer.dealerCity);
    if (cityExists) {
      this.autoPopulatedFields.add('city');
      this.certficateForm.get('city')?.setValue(this.dealer.dealerCity, { emitEvent: false });
      this.modifiedFields.add('city');
      this.manuallyFilledFields.delete('city');
    }
  }
}

}
